import {
  Glow2,
  Rectangle10,
  Rectangle11,
  Rectangle12,
  Rectangle13,
  Rectangle14,
  Rectangle15,
  Rectangle8,
  Rectangle9,
} from './RectangleFaces';
import Modem from './Modem';
import Starlink from './Starlink';
import IPad from './IPad';
import './empty-state.css';

const MagicBox = () => {
  return (
    <div className="pointer-events-none relative flex flex-1 items-end justify-center transition-all duration-500 ease-in-out group-hover:translate-y-5 group-hover:scale-90">
      <div className="relative h-[137.62px] w-[206px]">
        <div className="relative">
          <div className="absolute left-[103px] top-[37.4px] z-50 text-[#6C9DFF] transition-all duration-500 ease-in-out group-hover:text-[#4F78CB]">
            <Rectangle15 />
          </div>
          <div className="absolute left-[17px] top-[38.88px] z-50 text-[#6C9DFF] transition-all duration-500 ease-in-out group-hover:text-[#4B71BF]">
            <Rectangle14 />
          </div>
          <div className="absolute left-[107px] top-[41.5px] z-40 text-[#5C84D2] transition-all duration-500 ease-in-out group-hover:text-[#445F95]">
            <Rectangle9 />
          </div>
          <div className="absolute left-[41.5px] top-[42.5px] z-40 text-[#4B67A1] transition-all duration-500 ease-in-out group-hover:text-[#374A6F]">
            <Rectangle8 />
          </div>
        </div>
        <div className="relative z-30 h-full opacity-0 transition-all duration-300 ease-in-out group-hover:opacity-100">
          <div
            className="absolute left-[-25px] top-[-140px] z-30 transition-all duration-700 ease-in-out will-change-transform"
            style={{
              backfaceVisibility: 'hidden',
            }}
          >
            <Glow2 />
          </div>
          <Modem />
          <Starlink />
          <IPad />
        </div>
        <div className="absolute left-[104px] top-[3.5px] z-20 text-[#6C9DFF] transition-all duration-500 ease-in-out group-hover:text-[#4A6AB1]">
          <Rectangle13 />
        </div>
        <div className="absolute left-[22px] top-[3px] z-20 text-[#5882D5] transition-all duration-500 ease-in-out group-hover:text-[#46619D]">
          <Rectangle12 />
        </div>
        <div className="absolute left-[105px] top-[23px]">
          <Rectangle11 />
        </div>
        <div className="absolute left-[43px] top-[22px]">
          <Rectangle10 />
        </div>
      </div>
    </div>
  );
};

export default MagicBox;
